import { CourseCertificateEvidenceModel } from "@/api/cle-api";

import { DetailItem } from "./DetailItem";
import { StatusBadge } from "./StatusBadge";
import {
  formatEvidenceStatus,
  getEvidenceStatusVariant,
} from "./utils/evidenceStatus";
import { formatDateLong } from "./utils/formatters";
import { formatAiDecision } from "./utils/aiDecision";

interface CourseCertificateInformationProps {
  certificate: CourseCertificateEvidenceModel;
}

export const CourseCertificateInformation = ({
  certificate,
}: CourseCertificateInformationProps) => (
  <div className="c-card c-item-list">
    <h3 className="flex-100">Information</h3>
    <DetailItem label="Filnavn" value={certificate.fileName} />
    <DetailItem label="Type" value="Kursusbevis" />
    <DetailItem
      label="Status"
      value={
        <div className="d-flex align-items-center gap-2">
          <StatusBadge
            pill
            status={formatEvidenceStatus(certificate.status)}
            variant={getEvidenceStatusVariant(certificate.status)}
          />
        </div>
      }
    />
    <DetailItem
      label="AI-vurdering"
      value={formatAiDecision(certificate.aiDecision)}
    />
    <DetailItem
      label="Indberettet"
      value={certificate.isReported ? "Ja" : "Nej"}
    />
    <DetailItem
      label="Oprettet"
      value={formatDateLong(certificate.createdAt)}
    />
    <DetailItem
      label="Oprettet af"
      value={certificate.createdByUserName ?? "-"}
    />
  </div>
);
